<ng-template transloco let-t>
  {{ t('enums.navigationItemSpecificationType.tags.' + type) }}
</ng-template>
